module.exports = __webpack_public_path__ + "static/media/logo512.ba50938e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo512.png
// module id = 32
// module chunks = 1